import { Button, Card, CardBody } from '@nextui-org/react';
import { Icon } from '@iconify/react';

const MissingInfoCard = ({ onEdit }: { onEdit: () => void }) => (
  <Card shadow='sm' className='w-full p-4 bg-warning-50'>
    <CardBody className='flex flex-col items-center justify-center gap-4 py-8'>
      <Icon
        icon='mdi:alert-circle-outline'
        className='text-warning-500'
        width={40}
        height={40}
      />
      <div className='text-center'>
        <p className='text-lg font-semibold text-warning-700'>
          Información Incompleta
        </p>
        <p className='text-sm text-warning-600 mt-2'>
          Faltan datos necesarios para mostrar este análisis
        </p>
      </div>
      <Button
        color='primary'
        onClick={onEdit}
        startContent={<Icon icon='mdi:edit' />}
      >
        Editar Liquidación
      </Button>
    </CardBody>
  </Card>
);

export default MissingInfoCard;
